import { getLocale } from "src/i18n/i18n";
import { getCurrencyFromAccount } from "src/utils/account";

interface Localization {
    locale: string;
    currency: string;
}

export const localizationDefaults = {
    country: "US",
    currency: "USD",
    locale: "en-US",
};

/**
 * returns an object of locale and currency
 * the locale is from i18n
 * the currency is derived from the country in the Account's address
 */
const getLocalization = (): Localization => {
    const currency = getCurrencyFromAccount() || localizationDefaults.currency;
    return { locale: getLocale(), currency };
};

export { getLocalization };
